import { propSerializer } from 'ymodel'
import { TimeOfDay } from '../TimeOfDay'

propSerializer<TimeOfDay, number>(TimeOfDay, {
  deserialize: serialized => new TimeOfDay(serialized),
  serialize:   timeOfDay  => timeOfDay.minutes,
})